import Button from '@/components/ui/button/button.component';
import { StepIconTopbar } from './components/_step-icon-topbar.component';

export type TopbarConfigItem =
  | {
      type: 'button';
      side: 'left' | 'right';
      testId: string;
      text: React.ReactNode;
      onClick?: () => void;
      variant: 'ghost' | 'default' | 'secondary';
      buttonType?: 'submit' | 'button';
      disabled?: boolean;
      form?: string;
    }
  | {
      type: 'step';
      side: 'left' | 'right';
      variant?: 'default' | 'disabled' | 'completed';
      testId: string;
      text: React.ReactNode;
      onClick?: () => void;
      progress: number;
      index: number;
      buttonType?: 'submit' | 'button';
      form?: string;
    };

export interface TopbarProps extends React.HTMLAttributes<HTMLDivElement> {
  config: TopbarConfigItem[];
}

export const Topbar = ({ config }: TopbarProps) => {
  const mapValue = (config: TopbarConfigItem) => {
    if (config.type === 'button') {
      return (
        <Button
          key={config.testId}
          // eslint-disable-next-line react/jsx-handler-names
          onClick={config.onClick}
          data-testid={config.testId}
          variant={config.variant}
          form={config.form}
          type={config.buttonType}
          disabled={config.disabled}
        >
          {config.text}
        </Button>
      );
    }
    if (config.type === 'step') {
      return (
        <StepIconTopbar
          key={config.testId}
          data-testid={config.testId}
          variant={config.variant}
          progress={config.progress}
          text={config.text}
          index={config.index}
          // eslint-disable-next-line react/jsx-handler-names
          onClick={config.onClick}
          form={config.form}
          type={config.buttonType}
        />
      );
    }
  };
  return (
    <div className="fixed top-[64px] h-19 w-full px-18 flex justify-between items-center border-b border-b-other-stroke bg-white">
      <div className="flex flex-row justify-between items-center gap-x-4">
        {config.filter((config) => config.side === 'left').map(mapValue)}
      </div>
      <div className="flex flex-row justify-between items-center gap-x-4">
        {config.filter((config) => config.side === 'right').map(mapValue)}
      </div>
    </div>
  );
};
